












import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {DisplayEnum} from '@/types/enum';

interface NewDisplayEnum extends DisplayEnum {
  text: string;
}

@Component
export default class JudgementListSearchMenu extends Vue {
  @Prop({
    required: true,
    default: [],
    type: Array
  })
  private readonly data!: {[propName: string]: any}[];

  @Prop({
    required: false,
    type: String
  })
  private readonly emptyText?: string;

  @Prop({
    required: true,
    default: '',
    type: String
  })
  private readonly inputVal!: '';

  @Prop({
    required: true,
    default: '',
    type: String
  })
  private readonly labelName!: string;

  @Prop({
    required: true,
    default: '',
    type: String
  })
  private readonly valueName!: string;

  @Prop({required: true, default: false, type: Boolean})
  private readonly show!: boolean;

  @Prop({required: true, default: false, type: Boolean})
  private readonly isAdminSearchMenu!: boolean;


  @Watch('data', {immediate: true, deep: true})
  onDataChange() {
    this.$nextTick(() => {
      this.dataHandle();
    });
  }
  @Watch('inputVal', {immediate: true, deep: true})
  onInputValChange() {
    this.$nextTick(() => {
      this.dataHandle();
    });
  }
  private selectedIdx = -1;

  private resultList: NewDisplayEnum[] = [];

  private dataHandle(): void {
    const label = this.emptyText || '';
    if (this.inputVal.length) {
      const regexp = new RegExp(this.inputVal.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'gi');
      const result = this.data.filter(item => item[this.labelName].match(regexp));
      if (result.length) {
        this.resultList = result.map(list => {
          const labelName = this.isAdminSearchMenu ? `${list[this.labelName]}(${list.id})` : list[this.labelName];
          return {text: list[this.labelName], value: list[this.valueName], label: labelName.replace(regexp, '<span>$&</span>')};
        });
      } else {
        this.resultList = [{value: '0', label, text: ''}];
      }
    } else {
      this.resultList = [{value: '0', label, text: ''}];
    }
  }

  private itemClick(item: any) {
    if (item.value !== '0') {
      this.$emit('selected', this.valueName, item);
    }
  }
}
